import React from 'react';
import { startOfDay, endOfDay, isValid, parseISO, format } from 'date-fns';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { Button,  TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Loop } from '@material-ui/icons';
import { KeyboardDatePicker } from '@material-ui/pickers';

interface Props {
	setFilterValue: any;
	filterValue: any;
	initialValue: any;
	onApply: (filter: any) => void;
	open: boolean;
	close: () => void;
	isStockTransactionTab: boolean;
}

export const StockMonitoringFilterDialog = ({
	setFilterValue,
	filterValue,
	initialValue,
	onApply,
	open,
	close,
	isStockTransactionTab
}: Props) => {

	const onSubmit = () => {
		window.scrollTo(0, 0);
		let filter = {};

		const startDateValue = filterValue?.startDate 
			? (typeof filterValue.startDate === 'string' ? parseISO(filterValue.startDate) : filterValue.startDate)
			: null;
		filter['startDate'] = startDateValue && isValid(startDateValue)
			? format(startOfDay(startDateValue), 'yyyy-MM-dd')
			: null;

		const endDateValue = filterValue?.endDate 
			? (typeof filterValue.endDate === 'string' ? parseISO(filterValue.endDate) : filterValue.endDate)
			: null;
		filter['endDate'] = endDateValue && isValid(endDateValue)
			? format(endOfDay(endDateValue), 'yyyy-MM-dd')
			: null;

		filter['itemName'] = filterValue?.itemName !== '' ? filterValue?.itemName : null;
		filter['category'] = filterValue?.category !== '' ? filterValue?.category : null;
		filter['transactionType'] = isStockTransactionTab && filterValue?.transactionType
    ? filterValue.transactionType
    : null;
		onApply(filter);
		localStorage.setItem('stockMonitoringFilterArgs', JSON.stringify(filter));
	};

	console.log('filterValue', filterValue);

	const TRANSACTION_TYPE_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Stock In', value: 'STOCK_IN' },
  { label: 'Stock Out', value: 'STOCK_OUT' },
  { label: 'Stock Adjustment', value: 'STOCK_ADJUSTMENT' },
];


	return (
		<CommonDialog
			fullWidth={true}
			open={open}
			onClose={close}
			sections={{
				header: {
					dynamic: (
						<div className="">
							<div className="dialog-dynamic-content">
								<div
									className="session"
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
								>
									<div className="title flex-space">Advance Search</div>
									<div>
										<Button
											variant="outlined"
											size="small"
											disableElevation
											onClick={() => {
												window.scrollTo(0, 0);
												localStorage.removeItem('stockMonitoringFilterArgs');
												setFilterValue({ ...initialValue });
											}}
											startIcon={<Loop />}
											style={{
												color: '#ff9800',
												backgroundColor: 'white',
												borderColor: '#ff9800',
												borderStyle: '10px solid',
											}}
										>
											Reset
										</Button>
									</div>
								</div>
							</div>
						</div>
					),
				},
				body: () => (
					<form onSubmit={() => onSubmit()}>
						<div style={{ display: 'flex', width: '100%' }}>
							<div style={{ paddingRight: '6px', width: '50%' }}>
								<KeyboardDatePicker
									value={
										filterValue?.startDate
											? typeof filterValue.startDate === 'string'
												? parseISO(filterValue.startDate)
												: filterValue.startDate
											: null
									}
									margin="dense"
									autoOk
									label="Start Date"
									className="left date-icon"
									name="startDate"
									onChange={e =>
										setFilterValue({
											...filterValue,
											startDate: e ? format(startOfDay(e), 'yyyy-MM-dd') : null,
										})
									}
									format="dd/MM/yyyy"
									fullWidth
								/>
							</div>

							<div style={{ paddingRight: '6px', width: '50%' }}>
								<KeyboardDatePicker
									value={
										filterValue?.endDate
											? typeof filterValue.endDate === 'string'
												? parseISO(filterValue.endDate)
												: filterValue.endDate
											: null
									}
									margin="dense"
									autoOk
									label="End Date"
									className="right date-icon"
									name="endDate"
									onChange={e => {
										setFilterValue({
											...filterValue,
											endDate: e ? format(endOfDay(e), 'yyyy-MM-dd') : null,
										});
									}}
									format="dd/MM/yyyy"
									fullWidth
								/>
							</div>
						</div>
						{isStockTransactionTab && (
							<Autocomplete
								options={TRANSACTION_TYPE_OPTIONS}
								getOptionLabel={(option) => option.label}
								value={
									TRANSACTION_TYPE_OPTIONS.find(
										opt => opt.value === filterValue.transactionType
									) || TRANSACTION_TYPE_OPTIONS[0] // default All
								}
								onChange={(event, option) => {
									setFilterValue({
										...filterValue,
										transactionType: option?.value ?? '', // '' = All
									});
								}}
								clearOnEscape
								disableClearable={false} 
								renderInput={(params) => (
									<TextField
										{...params}
										label="Transaction Type"
										margin="dense"
										fullWidth
									/>
								)}
							/>
						)}

						{/* <TextField
							label="Item Name"
							fullWidth
							value={filterValue?.itemName || ''}
							margin="dense"
							name="itemName"
							onChange={e => {
								setFilterValue({
									...filterValue,
									itemName: e.target.value,
								});
							}}
						/>

						<TextField
							label="Category"
							fullWidth
							value={filterValue?.category || ''}
							margin="dense"
							name="category"
							onChange={e => {
								setFilterValue({
									...filterValue,
									category: e.target.value,
								});
							}}
						/> */}
					</form>
				),
				footer: {
					actions: [
						{
							displayText: 'Cancel',
							props: {
								onClick: () => {
									close();
								},
								variant: 'contained',
								color: 'primary',
							},
						},
						{
							displayText: 'Confirm',
							props: {
								onClick: () => {
									onSubmit();
									close();
								},
								variant: 'contained',
								color: 'primary',
							},
						},
					],
				},
			}}
		/>
	);
};

